const firebaseConfig = {
  apiKey: "AIzaSyBtlkkmDD4YBx8mYLkcRmu-unoyt25giyQ",
  authDomain: "projet-era.firebaseapp.com",
  databaseURL: "https://projet-era.firebaseio.com",
  projectId: "projet-era",
  storageBucket: "projet-era.appspot.com",
  messagingSenderId: "865918621335",
  appId: "1:865918621335:web:191f84e46014a19c7abbd2",
  measurementId: "G-ZWY62W1HED"
}

export default firebaseConfig